<template>
    <div>
        <DrUserinfo />
    </div>
</template>

<script>
import DrUserinfo from "./drUserinfoView.vue";
export default {
    components: {
        DrUserinfo,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
